import React from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';

import home from './../assets/icon/homepage.png';
import information from './../assets/icon/info.png';
import explore from './../assets/icon/explore.png';
import offer from './../assets/icon/offer.png';
import liveChat from './../assets/icon/liveChat.png';
import map from './../assets/icon/map.png';
import logout from './../assets/icon/logout.png';
import bell from './../assets/icon/bell.png';
import user from './../assets/icon/user.png';
import order from './../assets/icon/order.png';

const RootNav = styled.div`
	display: flex;
	height: 80px;
	background-color: #ffffff;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	margin-bottom: 20px;
	> a {
		text-decoration: none;
		color: #848b91;
		font-weight: 700;
		display: flex;
		justify-content: center;
		align-items: center;
		display: flex;
		flex-direction: column;
	}
`;

const NavIcon = styled.img`
	height: 24px;
	margin-bottom: 10px;
`;

const Navigation = () => {
	return (
		<RootNav>
			<NavLink
				to="/information"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={information} />
				Information
			</NavLink>
			<NavLink
				to="/map"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={map} />
				Map
			</NavLink>
			<NavLink
				to="/offer"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={offer} /> Offer
			</NavLink>

			<NavLink
				to="/concierge"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={bell} /> Concierge
			</NavLink>

			<NavLink
				to="/order"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={order} /> Order
			</NavLink>

			<NavLink
				to="/news"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={home} /> News
			</NavLink>
			<NavLink
				to="/livechat"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={liveChat} /> Live Chat
			</NavLink>
			<NavLink
				to="/user"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={user} /> User
			</NavLink>
			<NavLink
				to="/signout"
				activeStyle={{
					fontWeight: 700,
					color: '#e0a521'
				}}
			>
				<NavIcon src={logout} />
				Sign out
			</NavLink>
		</RootNav>
	);
};
export default Navigation;
